import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CombatImplants = _resolveComponent("CombatImplants")!
  const _component_GenericSubPanel = _resolveComponent("GenericSubPanel")!
  const _component_GenericPanel = _resolveComponent("GenericPanel")!

  return (_openBlock(), _createBlock(_component_GenericPanel, {
    "class-name": "pool-container",
    title: "COMBAT IMPLANTS",
    "title-font-size": "22px"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_GenericSubPanel, null, {
        default: _withCtx(() => [
          _createVNode(_component_CombatImplants)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}